<template>
  <van-popup
    v-model="visible"
    position="bottom"
    style="height: 60vh; overflow: hidden;"
    closeable
    @close="onClose"
  >
    <div class="container">
      <div class="title">{{ title }}</div>
      <div class="scroll">
        <list-item
          v-for="item in couponList"
          :key="item.couponId"
          :item="item"
          @callbaCoupon="onUpdate"
        />
      </div>
    </div>
  </van-popup>
</template>

<script>
import ListItem from '@/views/coupon/components/receive';
export default {
  components: { ListItem },
  data() {
    return {
      visible: false,
      couponList: [],
      title: '优惠',
      received: undefined, // 是否点击了领取按钮
      key: 0
    };
  },
  mounted() {
    // append 到 body 原因是放至van-list里面背景滚动无法锁定
    document.body.appendChild(this.$el);
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    /**
     * @param opts.branchIds Array<branchId>
     * @param opts.onClose 关闭弹出层时触发
     */
    show(opts) {
      this.received = false;
      this.opts = opts || {};
      this.getCanReceiveCouponList();
    },
    hide() {
      this.visible = false;
    },
    setTitle(title) {
      this.title = title;
    },
    useCache() {
      this.cache = true;
    },
    unCache() {
      this.cache = false;
    },
    onClose() {
      if (this.opts.onClose) {
        this.opts.onClose();
      }
    },
    onUpdate() {
      this.received = true;
      this.getCanReceiveCouponList();
    },
    /**
     * 获取可领取的优惠券
     */
    getCanReceiveCouponList() {
      const len = this.couponList.length;
      if (len) this.visible = true;
      if (this.cache && len) return;
      const parmes = {
        branchIds: this.opts.branchIds
      }
      this.http({
        url: 'order/coupon/getCanReceiveCouponList',
        method: 'post',
        parmes
      }).then((res) => {
        this.couponList = res.data;
        this.visible = true;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.container .title {
  height: 100px;
  line-height: 100px;
  text-align: center;
  font-size: 32px;
}
.container .scroll {
  flex: 1;
  overflow-y: auto;
  background-color: #f5f5f5;
  padding: 20px;
  padding-bottom: 0;
}
</style>
